// extracted by mini-css-extract-plugin
export default {"-large":"lhrGrTAfMEL41Gz70tSu","mobileVideoItem":"Dwovr54DG6KPsdIHv1Pj"};